import React from "react";
import Home from "./mainpage/Home"

function App() {

  return (
    <div>
     <Home/>
   </div>
    );
}

export default App;
